import React from 'react'

// 「YYGAME ONLY」悬浮水印：覆盖在视频播放/大图预览层，四角 + 中心共五处（显示时生效，与素材文件无关）
// 父容器需 relative；pointer-events-none 不挡交互
const cls = 'pointer-events-none absolute z-10 select-none rounded bg-black/40 px-3 py-1 text-[22px] font-bold tracking-widest text-white/70'

export default function WatermarkBadge() {
    return (
        <>
            <span className={`${cls} left-3 top-3`}>YYGAME ONLY</span>
            <span className={`${cls} right-3 top-3`}>YYGAME ONLY</span>
            <span className={`${cls} left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2`}>YYGAME ONLY</span>
            <span className={`${cls} left-3 bottom-3`}>YYGAME ONLY</span>
            <span className={`${cls} right-3 bottom-3`}>YYGAME ONLY</span>
        </>
    )
}
